/**
 * Unified URL parameter utilities.
 *
 * Provides helpers for reading query-string parameters from a URL
 * and for parsing legacy hash-fragment parameters.
 */

/**
 * Get all query parameters from a URL.
 * Defaults to the current page URL when no argument is provided.
 */
export function getUrlParams(url: string = window.location.href): Record<string, string> {
  const params: Record<string, string> = {};
  const urlObj = new URL(url);
  urlObj.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}

/**
 * Get a single query parameter by key from a URL.
 * Defaults to the current page URL when no url argument is provided.
 */
export function getUrlParam(key: string, url: string = window.location.href): string | null {
  const urlObj = new URL(url);
  return urlObj.searchParams.get(key);
}

/**
 * Parse query-style parameters from a hash fragment.
 * E.g. "#modal?vouchercode=ABC" → { vouchercode: "ABC" }
 */
export function parseHashParams(hash: string): Record<string, string> {
  const qIndex = hash.indexOf('?');
  if (qIndex === -1) return {};
  const params: Record<string, string> = {};
  const searchStr = hash.substring(qIndex + 1);
  new URLSearchParams(searchStr).forEach((value, key) => {
    params[key] = value;
  });
  return params;
}
